interface Installment {
  installment: number;
  value: string;
}

interface Brand {
  name: string;
  installments: Installment[];
}

interface RatesByOrigin {
  [origin: string]: Brand[];
}




export const adjustNewResponse = (paymentMethods) => {
  return paymentMethods.reduce((acc, method) => {
    const origin = method.paymentOriginModel.origin;
    if (!acc[origin]) {
      acc[origin] = [];
    }
    acc[origin].push(method);
    return acc;
  }, {});
};


const formatToNumber = (str) => {
  if (typeof str === "string") {
    const string = str.replace("R$", "").replace("%", "").replace(" ", "").replace(",", ".")
    return Number(string)
  } else {
    return str
  }
};

export function transformPaymentData(dataArray) {

  return dataArray.map(data => {
    let transformedRateType = data.rateType;

    if (data.paymentBrandModel?.id != null) {
      transformedRateType = "CUSTOM";
    }

    return {
      paymentMethod: data?.paymentMethodModel?.id,
      paymentBrand: data?.paymentBrandModel?.id || null,
      paymentOrigin: data?.paymentOriginModel?.id,
      repaymentDay: sanitizeNumber(data?.repaymentDayModel?.day),
      seller: data?.seller,
      rateType: transformedRateType,
      rates: data?.rates?.map(rate => ({
        installments: rate.installments,
        paymentFeeType: rate.paymentFeeType,
        paymentFeeValue: formatToNumber(rate.paymentFeeValue),
        rateLimitValue: formatToNumber(rate.rateLimitValue)
      }))
    };
  });
}

function sanitizeNumber(value) {
  if (typeof value === "string") {
    let sanitized = value.replace(/[^0-9.]/g, '');
    return parseFloat(sanitized) || 0;
  }
  return typeof value === "number" ? value : 0;
}





export const reverseAdjustNewResponse = (groupedPaymentMethods?: Record<string, any[]>) => {
  if (!groupedPaymentMethods || typeof groupedPaymentMethods !== 'object') {
    console.error("Erro: groupedPaymentMethods está indefinido ou não é um objeto válido", groupedPaymentMethods);
    return [];
  }

  return Object.entries(groupedPaymentMethods).flatMap(([origin, methods]) =>
    (Array.isArray(methods) ? methods : []).map(method => ({
      ...method,
    }))
  );
};


export function adjustResponse(response, type?: "PIX" | "BANK_SLIP" | "CREDIT_CARD_EARLY_SELLER") {
  const groupByOrigin = (paymentMethods) => {
    return paymentMethods.reduce((acc, method) => {
      const origin = method.paymentOriginModel.origin;
      if (!acc[origin]) {
        acc[origin] = [];
      }
      acc[origin].push({
        name: method.paymentBrandModel ? method.paymentBrandModel.brandCard : "Padrão",
        paymentMethods: method.paymentMethodModel,
        installments: method.rates.map((rate) => ({
          installment: rate.installments,
          value: String(rate.paymentFeeValue).includes("%")
            ? rate.paymentFeeValue
            : `${rate.paymentFeeValue}%`,
          rateLimitValue: rate.rateLimitValue,
          paymentFeeType: rate.paymentFeeType,
        })),
      });


      return acc;
    }, {});
  };

  const filteredPaymentMethods = response?.filter(
    (method) => method.paymentMethodModel.name === type
  );
  return groupByOrigin(filteredPaymentMethods);
}

export function adjustResponseRepasse(response, type?: "PIX" | "BANK_SLIP" | "CREDIT_CARD_EARLY_SELLER") {
  const groupByOrigin = (paymentMethods) => {
    return paymentMethods.reduce((acc, method) => {
      const origin = method.paymentOriginModel.origin;
      if (!acc[origin]) {
        acc[origin] = [];
      }
      acc[origin].push({
        name: method.paymentBrandModel ? method.paymentBrandModel.brandCard : "Padrão",
        day: method?.repaymentDayModel?.day,
      });
      return acc;
    }, {});
  };

  const filteredPaymentMethods = response.filter(
    (method) => method.paymentMethodModel.name === type
  );
  return groupByOrigin(filteredPaymentMethods);
}


export function invertRatesStructure(ratesByOrigin: RatesByOrigin): Record<string, Record<string, Installment[]>> {
  const invertedStructure: Record<string, Record<string, Installment[]>> = {};
  Object.entries(ratesByOrigin).forEach(([origin, brands]) => {
    brands.forEach((brand) => {
      if (!invertedStructure[brand.name]) {
        invertedStructure[brand.name] = {};
      }
      invertedStructure[brand.name][origin] = brand.installments;
    });
  });

  return invertedStructure;
}



